export default {
  recipeFilterNotAvailable: 'Pred filtrovaním podľa receptúry vyberte zariadenie',
};
